export default __webpack_public_path__ + "static/media/IM-Logo.a7715471.png";